import React, { Component } from "react";
import InvoiceCell from "./InvoiceCell";
import Button from "../../shared/buttons/Button";
import Store from "../../../content/Store";
import styles from "../../../assets/css/modules/claims/invoice-row.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setPaymentDetailsForClaimAndInvoice } from "../../../actions/claims/claimsActions";

const mapDispatchToInvoiceRow = (dispatch) => {
  return {
    setPaymentDetailsForClaimAndInvoice: (
      claimReference,
      partialInvoiceReference,
      history
    ) =>
      dispatch(
        setPaymentDetailsForClaimAndInvoice(
          claimReference,
          partialInvoiceReference,
          history
        )
      )
  };
};

export class InvoiceRow extends Component {
  constructor(props) {
    super(props);
    this.paymentDetailsOnClickHandler = this.paymentDetailsOnClickHandler.bind(
      this
    );
  }

  async paymentDetailsOnClickHandler() {
    await this.props.setPaymentDetailsForClaimAndInvoice(
      this.props.claimReference,
      this.props.invoice.PartialInvoiceReference,
      this.props.history
    );
  }

  render() {
    return (
      <div className={styles.invoiceRow}>
        <div className="row">
          <div className="col-lg-1 text-center text-lg-left">
            <i
              className={
                "icon-health-hand-cross display-4 font-weight-bold " +
                styles.displayIcon
              }
            />
          </div>
          <div className="col-lg-8 text-center text-lg-left">
            <InvoiceCell
              statusPanelOnClick={this.paymentDetailsOnClickHandler}
              invoice={this.props.invoice}
            />
          </div>
          <div className="col-lg-3 text-lg-right pt-3 text-center">
            <Button
              label={Store.ClaimDetails.paymentDetailsButtonLabel}
              aria-label={`${Store.ClaimDetails.paymentDetailsButtonLabel} ${this.props.invoice.InvoiceDate}`}
              buttonType="primaryBlueButton"
              onClick={this.paymentDetailsOnClickHandler}
            />
          </div>
        </div>
         {this.props.invoice.IsPaymentNeededByMember?
          (
          <div className="row">
            <div className="col-lg-1 "></div>
            <div className={"col-lg-11 text-center text-lg-left "  + styles.NoDetailsHeld}>
             <i className={"icon-info " + styles.cardIcon}/>
            <span>{Store.ClaimDetails.AlreadyPaidInfo}</span>
          </div>
          </div>
          ):null}
      </div>
    );
  }
}

export default withRouter(connect(null, mapDispatchToInvoiceRow)(InvoiceRow));
